module.exports = __webpack_public_path__ + "img/vertical-logo-white.b396e708.svg";